module.exports = __webpack_public_path__ + "static/media/tr808_closedhat_01.1a694aff.wav";